import React from 'react';
import { Modal } from '../../core/Modal';
import styles from './UpgradeModal.module.css';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;
  onUpgrade: () => Promise<void>;
  isLoading?: boolean;
}

export function UpgradeModal({
  isOpen,
  onClose,
  feature,
  onUpgrade,
  isLoading = false,
}: UpgradeModalProps) {
  const handleUpgrade = async () => {
    try {
      await onUpgrade();
    } catch (error) {
      console.error('Upgrade failed:', error);
      // You might want to show an error message here
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Upgrade Required">
      <div className={styles.content}>
        <div className={styles.icon}>✨</div>
        <h3 className={styles.title}>Unlock {feature}</h3>
        <p className={styles.description}>
          This feature requires a Pro subscription. Upgrade now to access:
        </p>

        <ul className={styles.features}>
          <li>✅ Unlimited projects</li>
          <li>✅ 3D shader access</li>
          <li>✅ Native embedding</li>
          <li>✅ Advanced export options</li>
          <li>✅ Priority support</li>
        </ul>

        <div className={styles.pricing}>
          <div className={styles.price}>
            <span className={styles.amount}>$9</span>
            <span className={styles.period}>/month</span>
          </div>
          <p className={styles.trial}>7-day free trial • Cancel anytime</p>
        </div>

        <div className={styles.actions}>
          <button
            className={styles.upgradeButton}
            onClick={handleUpgrade}
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Start Free Trial'}
          </button>
          <button
            className={styles.cancelButton}
            onClick={onClose}
            disabled={isLoading}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </Modal>
  );
}
